import { useEffect, useRef } from 'react';
import { useAnalytics } from '@components/analytics/hooks/useAnalytics';

interface Props {
  isVisible: boolean;
  allProps: any;
  isModal: boolean;
}

const useTrackModal = ({ isVisible = false, allProps, isModal = false }: Props) => {
  const { page } = useAnalytics();
  const wasTrackableRef = useRef(false);

  useEffect(() => {
    const isTrackable = isVisible && isModal;

    if (isTrackable && !wasTrackableRef.current && allProps) {
      page('modal_viewed', allProps);
    }

    wasTrackableRef.current = isTrackable;
  }, [isVisible, allProps, isModal, page]);
};

export default useTrackModal;
